module.exports = __webpack_public_path__ + "media/packs/images/flags/PS-1cced234e1b59f9849e828cc48097177.svg";